<div class="lead-info-container">
    <mat-tab-group class="lead-tabs" animationDuration="200ms" (selectedTabChange)="onTabChange($event)">
      <!-- Focus Tab -->
   <!-- Focus Tab -->
<!-- Complete Focus Tab -->
<mat-tab label="Focus">
    <div class="focus-tab-content">
      <!-- Focus Section -->
      <div class="focus-section">
        <!-- COUNTER BAR REMOVED -->
        
        <div class="focus-content" *ngIf="currentLead && (currentLead.note?.length || currentLead.tasks?.length || showChat || (callsEnabled && currentLead.last_call_time)); else noFocusData">
          <!-- Notes Section -->
          <div class="focus-container focus-notes-section" *ngIf="currentLead.note?.length">
            <div class="focus-category-header">
              <div class="decorated-header">
                <span class="dash-line"></span>
                <span class="header-text">NOTES</span>
                <span class="dash-line"></span>
              </div>
            </div>
            <div class="focus-items-container">
              <app-item
                *ngFor="let note of currentLead.note; let i = index"
                [note]="note"
                [focusMode]="true"
                (onTogglePin)="togglePin($event)">
              </app-item>
            </div>
          </div>
        
          <!-- Tasks Section -->
            <div class="focus-container focus-tasks-section" *ngIf="currentLead.tasks?.length">
                <div class="focus-category-header">
                <div class="decorated-header">
                    <span class="dash-line"></span>
                    <span class="header-text">TASKS</span>
                    <span class="dash-line"></span>
                </div>
                </div>
                <div class="focus-items-container">
                @for (record of currentLead.tasks; track record.id) {
                    <app-card-item
                    [data]="record"
                    [showFocus]="true"
                    (click)="openActivityModal(record)"
                    (markCompletedAction)="markCompleted($event)"
                    style="cursor: pointer;">
                    </app-card-item>
                }
                </div>
            </div>
  
          <!-- Chat Section -->
          <div class="focus-container focus-chat-section" *ngIf="chat && showChat">
            <div class="focus-category-header">
              <div class="decorated-header">
                <span class="dash-line"></span>
                <span class="header-text">CHATS</span>
                <span class="dash-line"></span>
              </div>
            </div>
            <div class="focus-items-container">
              <div class="chat-item" (click)="openChat()">
                <app-chat-item [focusMode]="true" [chat]="chat" [leadName]="currentLead.fullName" [repName]="fullNameCurrentUser"></app-chat-item>
              </div>
            </div>
          </div>

<!-- Call Statistics Section - SIMPLE CLEAN VERSION -->

<!-- Call Statistics (only when calls enabled and has call data) -->
<div class="focus-container focus-call-stats-section" *ngIf="callsEnabled && currentLead?.last_call_time">
    <div class="focus-category-header">
      <div class="decorated-header">
        <span class="dash-line"></span>
        <span class="header-text">CALLS</span>
        <span class="dash-line"></span>
      </div>
    </div>
    <div class="focus-items-container">
      <div class="call-stats-simple">
        <div class="call-stat-row">
          <span class="call-stat-label">Last Call</span>
          <span class="call-stat-value">{{ currentLead.last_call_time | date:'MMM d, yyyy • h:mm a' }}</span>
        </div>
        <div class="call-stat-row" *ngIf="currentLead.lastCallDisposition">
          <span class="call-stat-label">Disposition</span>
          <span class="call-stat-value">{{ currentLead.lastCallDisposition?.name }}</span>
        </div>
        <div class="call-stat-row">
          <span class="call-stat-label">Call Summary</span>
          <span class="call-stat-value">{{ currentLead.total_connected_calls || 0 }} connected of {{ currentLead.total_call_attempts || 0 }} attempts</span>
        </div>
      </div>
    </div>
  </div>
        </div>
        
        <!-- No Data Template -->
        <ng-template #noFocusData>
          <div class="empty-focus-state">
            <div class="empty-state-illustration">
              <mat-icon class="illustration-icon primary">visibility</mat-icon>
              <mat-icon class="illustration-icon secondary">assignment</mat-icon>
              <mat-icon class="illustration-icon tertiary">chat_bubble_outline</mat-icon>
            </div>
            <h2>No Focus Items</h2>
            <p>There are no notes, tasks, or conversations currently pinned to focus.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </mat-tab>
  
      <!-- Lead Info Tab -->
      <mat-tab label="Lead Info">
        <div class="lead-info-tab-content">
          <mat-accordion class="left-section" [multi]="false">
  
            <!-- Personal Info Panel -->
            <mat-expansion-panel [disabled]="editMode.personalInfoForm && !personalInfoForm.valid" (opened)="onPanelOpened('personalInfoForm')" (closed)="onPanelClosed('personalInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">person</mat-icon>
                        Personal Info
                    </mat-panel-title>
                    <button [disabled]="editMode.personalInfoForm && !personalInfoForm.valid" mat-icon-button class="edit-icon" (click)="toggleEdit('personalInfoForm',$event)">
                        <mat-icon>{{ editMode.personalInfoForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <ng-container *ngIf="!editMode.personalInfoForm; else personalInfoEdit">
                    <div class="personalInfo">
                        <div class="infoRow">
                            <p class="label">First Name:</p>
                            <p class="value">{{ personalInfoForm.get('name')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Last Name:</p>
                            <p class="value">{{ personalInfoForm.get('lastName')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Birth Date:</p>
                            <p class="value">
                                {{ personalInfoForm.get('birth_date')?.value ? (personalInfoForm.get('birth_date')?.value) : 'No data' }}
                            </p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Gender:</p>
                            <p class="value">{{ personalInfoForm.get('gender')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Marital Status:</p>
                            <p class="value">{{ personalInfoForm.get('marital_status')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Ethnicity/Race:</p>
                            <p class="value">{{ personalInfoForm.get('race_ethnicity')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Highest Degree:</p>
                            <p class="value">{{ personalInfoForm.get('highestDegreeEarned')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Graduation Year:</p>
                            <p class="value">{{ personalInfoForm.get('highSchoolYearGraduation')?.value || 'No data' }}</p>
                        </div>
                    </div>
                </ng-container>
                <ng-template #personalInfoEdit>
                    <form [formGroup]="personalInfoForm" style="font-size: 14px">
                        <mat-form-field appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="name">
                            <mat-icon matSuffix>badge</mat-icon>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName">
                            <mat-icon matSuffix>badge</mat-icon>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Birth Date</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="birth_date" (dateChange)="onDateChange($event)">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Gender</mat-label>
                            <mat-select formControlName="gender">
                                <mat-option *ngFor="let gender of genders" [value]="gender.id">{{ gender.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Marital Status</mat-label>
                            <mat-select formControlName="marital_status">
                                <mat-option *ngFor="let maritialStatus of maritalStatuses" [value]="maritialStatus.id">
                                    {{ maritialStatus.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Ethnicity/Race</mat-label>
                            <mat-select formControlName="race_ethnicity">
                                <mat-option *ngFor="let ethnicitie of ethnicities" [value]="ethnicitie.id">{{ ethnicitie.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Highest Degree Earned</mat-label>
                            <mat-select formControlName="highestDegreeEarned">
                                <mat-option *ngFor="let HighestDgree of degreeOptions" [value]="HighestDgree.id">
                                    {{ HighestDgree.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
  
                        <mat-form-field appearance="outline">
                            <mat-label>Graduation Year</mat-label>
                            <input matInput formControlName="highSchoolYearGraduation" placeholder="e.g. 2016" maxlength="4">
                            <mat-icon matSuffix>school</mat-icon>
                        </mat-form-field>
                    </form>
                </ng-template>
            </mat-expansion-panel>
           
            <!-- Contact Info Panel -->
            <mat-expansion-panel [disabled]="editMode.contactInfoForm && !contactInfoForm.valid" (opened)="onPanelOpened('contactInfoForm')" (closed)="onPanelClosed('contactInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">contact_mail</mat-icon>
                        Contact Info
                    </mat-panel-title>
                    <button [disabled]="editMode.contactInfoForm && !contactInfoForm.valid" mat-icon-button class="edit-icon" (click)="toggleEdit('contactInfoForm', $event)">
                        <mat-icon>{{ editMode.contactInfoForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <ng-container *ngIf="!editMode.contactInfoForm; else contactInfoEdit">
                    <div class="contactInfo">
                        <div class="infoRow">
                            <p class="label">Email:</p>
                            <p class="value">{{ contactInfoForm.get('email')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Phone Number:</p>
                            <div class="value" style="display: flex; align-items: center; gap: 8px;">
                                <span>{{contactInfoForm.get('prefix')?.value}} {{contactInfoForm.get('phoneNumber')?.value}}</span>
                                <app-compact-call-button
                                    *ngIf="callsEnabled && !editMode.contactInfoForm && contactInfoForm.get('phoneNumber')?.value && contactInfoForm.get('prefix')?.value"
                                    [phoneNumber]="(contactInfoForm.get('prefix')?.value || '') + (contactInfoForm.get('phoneNumber')?.value || '')"
                                    [leadId]="currentLead?.id"
                                    [leadName]="currentLead?.fullName"
                                    size="small"
                                    [showText]="false">
                                </app-compact-call-button>
                            </div>
                        </div>
                        <div class="infoRow">
                            <p class="label">Mobile Phone:</p>
                            <div class="value" style="display: flex; align-items: center; gap: 8px;">
                                <span>{{ contactInfoForm.get('mobilePhone')?.value }}</span>
                                <app-compact-call-button
                                    *ngIf="callsEnabled && !editMode.contactInfoForm && contactInfoForm.get('mobilePhone')?.value"
                                    [phoneNumber]="contactInfoForm.get('mobilePhone')?.value"
                                    [leadId]="currentLead?.id"
                                    [leadName]="currentLead?.fullName"
                                    size="small"
                                    [showText]="false">
                                </app-compact-call-button>
                            </div>
                        </div>
                        <div class="infoRow">
                            <p class="label">Home Phone:</p>
                            <div class="value" style="display: flex; align-items: center; gap: 8px;">
                                <span>{{ contactInfoForm.get('homePhone')?.value }}</span>
                                <app-compact-call-button
                                    *ngIf="callsEnabled && !editMode.contactInfoForm && contactInfoForm.get('homePhone')?.value"
                                    [phoneNumber]="contactInfoForm.get('homePhone')?.value"
                                    [leadId]="currentLead?.id"
                                    [leadName]="currentLead?.fullName"
                                    size="small"
                                    [showText]="false">
                                </app-compact-call-button>
                            </div>
                        </div>
                        <div class="infoRow">
                            <p class="label">Address:</p>
                            <p class="value">{{ contactInfoForm.get('address')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">City:</p>
                            <p class="value">{{ contactInfoForm.get('city')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">State:</p>
                            <p class="value">{{ contactInfoForm.get('state')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Zip Code:</p>
                            <p class="value">{{ contactInfoForm.get('zip_code')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Preferred Method:</p>
                            <p class="value">{{ contactInfoForm.get('preferred_contact_method')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Best Time to Call:</p>
                            <p class="value">{{ contactInfoForm.get('best_time_to_call')?.value }}</p>
                        </div>
                    </div>
                </ng-container>
                <ng-template #contactInfoEdit>
                    <form [formGroup]="contactInfoForm" style="font-size: 14px">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput type="email" formControlName="email" (blur)="onEmailBlur()" />
                            @if (contactInfoForm.get('email')?.errors?.['required']) {
                              <mat-error>Email is required</mat-error>
                            }
                            @if (contactInfoForm.get('email')?.errors?.['emailExists']) {
                              <mat-error>Email already exist</mat-error>
                            }
                          </mat-form-field>
                          
                          <div class="phone-field-row">
                            <mat-form-field appearance="outline" class="phone-prefix-field">
                                <mat-label>Prefix</mat-label>
                              <mat-select formControlName="prefix" placeholder="Prefix">
                                @for(prefix of prefixes; track $index) {
                                  <mat-option [value]="prefix.prefix">{{ prefix.prefix }} {{ prefix.flag }}</mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          
                            <mat-form-field appearance="outline" class="phone-number-field">
                                <mat-label>Phone Number</mat-label>
                              <input matInput formControlName="phoneNumber">
                              <mat-icon matSuffix>phone</mat-icon>
                            </mat-form-field>
                        </div>
                          
                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Phone</mat-label>
                            <input matInput formControlName="mobilePhone">
                            <mat-icon matSuffix>smartphone</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>Home Phone</mat-label>
                            <input matInput formControlName="homePhone">
                            <mat-icon matSuffix>home</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <input matInput formControlName="address">
                            <mat-icon matSuffix>home</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city">
                            <mat-icon matSuffix>location_city</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="state">
                            <mat-icon matSuffix>map</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>Zip Code</mat-label>
                            <input matInput formControlName="zip_code">
                            <mat-icon matSuffix>markunread_mailbox</mat-icon>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>Preferred Method</mat-label>
                            <mat-select formControlName="preferred_contact_method">
                                <mat-option *ngFor="let method of contactMethods" [value]="method.id">{{ method.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
            
                        <mat-form-field appearance="outline">
                            <mat-label>Best Time to Call</mat-label>
                            <mat-select formControlName="best_time_to_call">
                                <mat-option *ngFor="let method of bestTimeToCallOptions" [value]="method.id">{{ method.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>
                </ng-template>
            </mat-expansion-panel>
            
            <!-- Academic & Program Information Panel -->
            <mat-expansion-panel [disabled]="editMode.academicInfoForm && !academicInfoForm.valid" (opened)="onPanelOpened('academicInfoForm')" (closed)="onPanelClosed('academicInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">school</mat-icon>
                        Academic & Program
                    </mat-panel-title>
                    <button [disabled]="editMode.academicInfoForm && !academicInfoForm.valid" mat-icon-button class="edit-icon" (click)="toggleEdit('academicInfoForm', $event)">
                        <mat-icon>{{ editMode.academicInfoForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <ng-container *ngIf="!editMode.academicInfoForm; else academicInfoEdit">
                    <div class="academicInfo">
                        <div class="infoRow">
                            <p class="label">Campus:</p>
                            <p class="value">{{ academicInfoForm.get('campus')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Program:</p>
                            <p class="value">{{ academicInfoForm.get('program')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Cohorts:</p>
                            <p class="value">{{ academicInfoForm.get('cohort_start')?.value }}</p>
                        </div>
                    </div>
                </ng-container>
                <ng-template #academicInfoEdit>
                    <form [formGroup]="academicInfoForm" style="font-size: 14px">
                        <app-select
                            [options]="campuses"
                            formControlName="campus"
                            [displayKey]="'name'"
                            [placeholder]="'Campus'"
                            (selectionChange)="onCampusChange($event)">
                        </app-select>
                        <app-select
                            [options]="programs"
                            formControlName="program"
                            [displayKey]="'name'"
                            [placeholder]="'Program of Interest'"
                            (selectionChange)="onProgramChange($event)">
                        </app-select>
            
                        <app-select
                            [options]="cohorts"
                            [displayKey]="'title'"
                            [placeholder]="'Cohort program'"
                            formControlName="cohort_start">
                        </app-select>
                    </form>
                </ng-template>
            </mat-expansion-panel>
            
            <!-- Citizenship & Military Information Panel -->
            <mat-expansion-panel (opened)="onPanelOpened('citizenshipInfoForm')" (closed)="onPanelClosed('citizenshipInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">public</mat-icon>
                        Citizenship & Military
                    </mat-panel-title>
                    <button
                        mat-icon-button
                        class="edit-icon"
                        (click)="toggleEdit('citizenshipInfoForm', $event)">
                        <mat-icon>{{ editMode.citizenshipInfoForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
            
                <ng-container *ngIf="!editMode.citizenshipInfoForm; else citizenshipInfoEdit">
                    <div class="citizenshipInfo">
                        <div class="infoRow">
                            <p class="label">U.S. Citizen:</p>
                            <p class="value">{{ citizenshipInfoForm.get('usCitizen')?.value ? 'Yes' : 'No' }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">VA/Military:</p>
                            <p class="value">{{ citizenshipInfoForm.get('vaMilitary')?.value ? 'Yes' : 'No' }}</p>
                        </div>
                    </div>
                </ng-container>
            
                <ng-template #citizenshipInfoEdit>
                    <form [formGroup]="citizenshipInfoForm" style="font-size: 14px">
                        <div class="checkbox-container">
                            <p class="checkbox-label">U.S. Citizen:</p>
                            <mat-checkbox formControlName="usCitizen"></mat-checkbox>
                        </div>
                        <div class="checkbox-container">
                            <p class="checkbox-label">VA/Military:</p>
                            <mat-checkbox formControlName="vaMilitary"></mat-checkbox>
                        </div>
                    </form>
                </ng-template>
            </mat-expansion-panel>

            <!-- Referral Information Panel -->
            <mat-expansion-panel [disabled]="editMode.referralInfoForm && !referralInfoForm.valid" 
                            (opened)="onPanelOpened('referralInfoForm')" 
                            (closed)="onPanelClosed('referralInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">people_alt</mat-icon>
                        Referral Information
                    </mat-panel-title>
                    <button [disabled]="editMode.referralInfoForm && !referralInfoForm.valid" 
                        mat-icon-button 
                        class="edit-icon" 
                        (click)="toggleEdit('referralInfoForm', $event)">
                        <mat-icon>{{ editMode.referralInfoForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                
                <ng-container *ngIf="!editMode.referralInfoForm; else referralInfoEdit">
                    <div class="referralInfo" *ngIf="currentLead?.referral; else noReferral">
                        <div class="infoRow" *ngIf="currentLead.referral.referredByUser">
                            <p class="label">Referred By:</p>
                            <p class="value">Staff - {{ currentLead.referral.referredByUser.name }} {{ currentLead.referral.referredByUser.lastName }}</p>
                        </div>
                        <div class="infoRow" *ngIf="currentLead.referral.referredByLead">
                            <p class="label">Referred By:</p>
                            <p class="value">Lead - {{ currentLead.referral.referredByLead.fullName }}</p>
                        </div>
                        <div class="infoRow" *ngIf="currentLead.referral.referralCode">
                            <p class="label">Referral Code:</p>
                            <p class="value">{{ currentLead.referral.referralCode }}</p>
                        </div>
                        <div class="infoRow" *ngIf="currentLead.referral.note">
                            <p class="label">Referral Note:</p>
                            <div class="value note-content" [innerHTML]="currentLead.referral.note"></div>
                        </div>
                    </div>
                    <ng-template #noReferral>
                        <div class="no-data-message">
                            <mat-icon>info_outline</mat-icon>
                            <p>No referral information available</p>
                        </div>
                    </ng-template>
                </ng-container>
                
                <ng-template #referralInfoEdit>
                    <form [formGroup]="referralInfoForm" style="font-size: 14px">
                        <!-- Referral Type -->
                        <mat-form-field appearance="outline">
                            <mat-label>Referral Type</mat-label>
                            <mat-select formControlName="referralType" (selectionChange)="onReferralTypeChange($event)">
                                <mat-option value="">None</mat-option>
                                <mat-option value="user">Staff Member</mat-option>
                                <mat-option value="lead">Another Lead</mat-option>
                            </mat-select>
                        </mat-form-field>
                        
                        <!-- Staff Member Selector (shown only if referral type is 'user') -->
                        <app-select
                            *ngIf="referralInfoForm.get('referralType')?.value === 'user'"
                            [options]="users"
                            [placeholder]="'Referred by Staff Member'"
                            formControlName="referredById"
                            [formControl]="$any(referralInfoForm).get('referredById')">
                        </app-select>
                        
                        <!-- Lead Selector (shown only if referral type is 'lead') -->
                        <app-auto-complete
                            *ngIf="referralInfoForm.get('referralType')?.value === 'lead'"
                            [options]="referralOptions"
                            [label]="'Referred by Lead'"
                            [formControl]="$any(referralInfoForm).get('referredById')"
                            (valueSelected)="referralChange($event)"
                            (valueChanged)="handleReferralValueChanged($event)">
                        </app-auto-complete>
                        
                        <!-- Referral Code -->
                        <mat-form-field appearance="outline" *ngIf="referralInfoForm.get('referralType')?.value">
                            <mat-label>Referral Code</mat-label>
                            <input matInput formControlName="referralCode" />
                        </mat-form-field>
                        
                        <!-- Referral Note -->
                        <div class="notes" *ngIf="referralInfoForm.get('referralType')?.value">
                            <app-html-editor 
                                [formControl]="$any(referralInfoForm).get('referralNote')"
                                [height]="'100px'"
                                [showNoteBackground]="true"
                                placeholder="Referral Notes"
                                [quillModule]="quillModule"
                                title="Referral Notes">
                            </app-html-editor>
                        </div>
                    </form>
                </ng-template>
            </mat-expansion-panel>

            <!-- Lead & Enrollment Information Panel -->
            <mat-expansion-panel [disabled]="editMode.leadInfoForm && !leadInfoForm.valid" (opened)="onPanelOpened('leadInfoForm')" (closed)="onPanelClosed('leadInfoForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">assignment_ind</mat-icon>
                        Lead & Enrollment
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container>
                    <div class="leadInfo">
                        <div class="infoRow">
                            <p class="label">Lead Owner:</p>
                            <p class="value">{{ leadInfoForm.get('user')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Secondary Lead Owner:</p>
                            <p class="value">{{ leadInfoForm.get('secondaryUser')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Lead In Date:</p>
                            <p class="value">
                                {{ leadInfoForm.get('lead_in_date')?.value ? (leadInfoForm.get('lead_in_date')?.value | customDate) : 'No data' }}
                            </p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Lead Source:</p>
                            <p class="value">{{ leadInfoForm.get('source')?.value }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">Lead Vendor Source:</p>
                            <p class="value">{{ leadInfoForm.get('vendorSource')?.value }}</p>
                        </div>
                    </div>
                </ng-container>
            </mat-expansion-panel>

            <!-- Payment Plan Panel -->
            <mat-expansion-panel [disabled]="editMode.paymentPlanForm && !paymentPlanForm.valid" (opened)="onPanelOpened('paymentPlanForm')" (closed)="onPanelClosed('paymentPlanForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">payments</mat-icon>
                        Payment Plan
                    </mat-panel-title>
                    <button [disabled]="editMode.paymentPlanForm && !paymentPlanForm.valid" mat-icon-button class="edit-icon" (click)="toggleEdit('paymentPlanForm', $event)">
                        <mat-icon>{{ editMode.paymentPlanForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <ng-container *ngIf="!editMode.paymentPlanForm; else paymentPlanEdit">
                    <div class="leadInfo">
                        <div class="infoRow">
                            <p class="label">Start Date:</p>
                            <p class="value">
                                {{ paymentPlanForm.get('payment_plan_start_date')?.value 
                                ? (paymentPlanForm.get('payment_plan_start_date')?.value | date:'MMM d, yyyy') 
                                : 'No data' }}
                            </p>
                        </div>
                        <div class="infoRow">
                            <p class="label">End Date:</p>
                            <p class="value">
                                {{ paymentPlanForm.get('payment_plan_end_date')?.value 
                                ? (paymentPlanForm.get('payment_plan_end_date')?.value | date:'MMM d, yyyy') 
                                : 'No data' }}
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-template #paymentPlanEdit>
                    <form [formGroup]="paymentPlanForm" class="edit-form">
                        <mat-form-field appearance="outline">
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="paymentStartPicker" formControlName="payment_plan_start_date">
                            <mat-datepicker-toggle matSuffix [for]="paymentStartPicker"></mat-datepicker-toggle>
                            <mat-datepicker #paymentStartPicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>End Date</mat-label>
                            <input matInput [matDatepicker]="paymentEndPicker" formControlName="payment_plan_end_date">
                            <mat-datepicker-toggle matSuffix [for]="paymentEndPicker"></mat-datepicker-toggle>
                            <mat-datepicker #paymentEndPicker></mat-datepicker>
                        </mat-form-field>
                    </form>
                    <!-- AFTER: add the error block between the end date field and </ng-template> -->
                    <div class="fa-date-error" *ngIf="paymentPlanForm.hasError('startAfterEnd')">
                        <mat-icon>error_outline</mat-icon>
                        <span>Start date cannot be after end date</span>
                    </div>
                    </ng-template>
            </mat-expansion-panel>


            <!-- Financial Aid Panel -->
            <mat-expansion-panel [disabled]="editMode.financialAidForm && !financialAidForm.valid"
                                 (opened)="onPanelOpened('financialAidForm')"
                                 (closed)="onPanelClosed('financialAidForm')">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon class="panel-icon">account_balance</mat-icon>
                        Financial Aid
                    </mat-panel-title>
                    <button [disabled]="editMode.financialAidForm && !financialAidForm.valid"
                            mat-icon-button class="edit-icon"
                            (click)="toggleEdit('financialAidForm', $event)">
                        <mat-icon>{{ editMode.financialAidForm ? 'done' : 'edit' }}</mat-icon>
                    </button>
                </mat-expansion-panel-header>

                <!-- ── VIEW MODE ── -->
                <!-- ── VIEW MODE ── -->
                <ng-container *ngIf="!editMode.financialAidForm; else financialAidEdit">
                    <div class="fa-view">

                        <!-- Status Badges -->
                        <div class="fa-badges-row">
                            <div class="fa-badge-item">
                                <span class="fa-badge-label">FA Status</span>
                                <span *ngIf="currentLead?.faStatus" class="fa-status-badge" [style.background-color]="currentLead.faStatus.color">
                                    {{ currentLead.faStatus.name }}
                                </span>
                                <span *ngIf="!currentLead?.faStatus" class="fa-status-badge fa-badge-empty">Not set</span>
                            </div>
                            <div class="fa-badge-item">
                                <span class="fa-badge-label">Overall</span>
                                <span *ngIf="currentLead?.faOverallStatus" class="fa-status-badge" [style.background-color]="currentLead.faOverallStatus.color">
                                    {{ currentLead.faOverallStatus.name }}
                                </span>
                                <span *ngIf="!currentLead?.faOverallStatus" class="fa-status-badge fa-badge-empty">Not set</span>
                            </div>
                            <div class="fa-badge-item">
                                <span class="fa-badge-label">Verification</span>
                                <span class="fa-status-badge fa-badge-neutral">{{ currentLead?.faVerificationStatus?.name || 'Not set' }}</span>
                            </div>
                        </div>

                        <!-- Key Info -->
                        <div class="infoRow">
                            <p class="label">Dependency Type</p>
                            <p class="value">{{ currentLead?.faDependencyType?.name || 'Not set' }}</p>
                        </div>
                        <div class="infoRow">
                            <p class="label">FA Advisor</p>
                            <p class="value">{{ currentLead?.faAdvisor ? (currentLead.faAdvisor.name + ' ' + currentLead.faAdvisor.lastName) : 'Not assigned' }}</p>
                        </div>

                        <!-- FAFSA -->
                        <div class="fa-card">
                            <div class="fa-card-header">
                                <mat-icon class="fa-card-icon">description</mat-icon>
                                <span>FAFSA</span>
                            </div>
                            <div class="fa-card-body">
                                <div class="infoRow">
                                    <p class="label">Filed</p>
                                    <p class="value" [class.fa-yes]="currentLead?.fafsa_filed" [class.fa-no]="!currentLead?.fafsa_filed">
                                        {{ currentLead?.fafsa_filed ? 'Yes' : 'No' }}
                                    </p>
                                </div>
                                <div class="infoRow" *ngIf="currentLead?.fafsa_submitted_at">
                                    <p class="label">Submitted</p>
                                    <p class="value">{{ currentLead.fafsa_submitted_at | date:'MMM d, yyyy' }}</p>
                                </div>
                                <div class="fa-doc-row" *ngIf="currentLead?.fafsa_document_key">
                                    <a class="fafsa-doc-link" (click)="openFafsaDocument()">
                                        <mat-icon>open_in_new</mat-icon>
                                        {{ currentLead.fafsa_document_name || 'View document' }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Dates -->
                        <div class="fa-card">
                            <div class="fa-card-header">
                                <mat-icon class="fa-card-icon">event</mat-icon>
                                <span>Dates</span>
                            </div>
                            <div class="fa-card-body">
                                <div class="infoRow">
                                    <p class="label">Appointment</p>
                                    <p class="value">{{ currentLead?.fa_appointment_at ? (currentLead.fa_appointment_at | date:'MMM d, yyyy') : '—' }}</p>
                                </div>
                                <div class="infoRow">
                                    <p class="label">Completed</p>
                                    <p class="value">{{ currentLead?.fa_completed_at ? (currentLead.fa_completed_at | date:'MMM d, yyyy') : '—' }}</p>
                                </div>
                                <div class="infoRow">
                                    <p class="label">Next Appointment</p>
                                    <p class="value">{{ currentLead?.expected_start_date ? (currentLead.expected_start_date | date:'MMM d, yyyy') : '—' }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- Award -->
                        <div class="fa-card">
                            <div class="fa-card-header">
                                <mat-icon class="fa-card-icon">payments</mat-icon>
                                <span>Award</span>
                            </div>
                            <div class="fa-card-body">
                                <div class="infoRow">
                                    <p class="label">SAR Received</p>
                                    <p class="value" [class.fa-yes]="currentLead?.sar_received" [class.fa-no]="!currentLead?.sar_received">
                                        {{ currentLead?.sar_received ? 'Yes' : 'No' }}
                                    </p>
                                </div>
                                <div class="infoRow">
                                    <p class="label">SAI Amount</p>
                                    <p class="value">{{ currentLead?.sai_amount != null ? ('$' + currentLead.sai_amount) : '—' }}</p>
                                </div>
                                <div class="infoRow">
                                    <p class="label">Letter Sent</p>
                                    <p class="value">
                                        {{ currentLead?.award_letter_sent ? 'Yes' : 'No' }}
                                        <span *ngIf="currentLead?.award_letter_sent_at" class="fa-date-inline">
                                            ({{ currentLead.award_letter_sent_at | date:'MMM d, yyyy' }})
                                        </span>
                                    </p>
                                </div>
                                <div class="infoRow">
                                    <p class="label">Aid Status</p>
                                    <p class="value"
                                       [class.fa-yes]="currentLead?.aid_accepted === true"
                                       [class.fa-no]="currentLead?.aid_accepted === false">
                                        {{ currentLead?.aid_accepted === true ? 'Accepted' : currentLead?.aid_accepted === false ? 'Declined' : 'Pending' }}
                                        <span *ngIf="currentLead?.aid_amount != null" class="fa-amount-inline">&mdash; ${{ currentLead.aid_amount }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="fa-notes-section" *ngIf="currentLead?.fa_notes">
                            <div class="fa-card-header">
                                <mat-icon class="fa-card-icon">notes</mat-icon>
                                <span>Notes</span>
                            </div>
                            <div class="fa-notes-content" [innerHTML]="currentLead.fa_notes"></div>
                        </div>

                    </div>
                </ng-container>

                <!-- ── EDIT MODE ── -->
                <ng-template #financialAidEdit>
                    <form [formGroup]="financialAidForm" class="fa-edit-form">

                        <!-- Sub-section: Status & Classification -->
                        <!-- Sub-section: Status & Classification -->
                        <div class="fa-edit-subsection">
                            <div class="fa-subsection-header">
                                <mat-icon class="fa-subsection-icon">tune</mat-icon>
                                <span>Status & Classification</span>
                            </div>
                            <div class="fa-subsection-body">
                                <mat-form-field appearance="outline">
                                    <mat-label>FA Status</mat-label>
                                    <mat-select formControlName="fa_status_id">
                                        <mat-option [value]="null">None</mat-option>
                                        <mat-option *ngFor="let status of faStatuses" [value]="status.id">
                                            {{ status.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Overall Status</mat-label>
                                    <mat-select formControlName="fa_overall_status_id">
                                        <mat-option [value]="null">None</mat-option>
                                        <mat-option *ngFor="let status of faOverallStatuses" [value]="status.id">
                                            {{ status.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Dependency Type</mat-label>
                                    <mat-select formControlName="fa_dependency_type_id">
                                        <mat-option [value]="null">None</mat-option>
                                        <mat-option *ngFor="let type of faDependencyTypes" [value]="type.id">
                                            {{ type.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Verification Status</mat-label>
                                    <mat-select formControlName="fa_verification_status_id">
                                        <mat-option [value]="null">None</mat-option>
                                        <mat-option *ngFor="let status of faVerificationStatuses" [value]="status.id">
                                            {{ status.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Sub-section: Advisor & Schedule -->
                        <div class="fa-edit-subsection">
                            <div class="fa-subsection-header">
                                <mat-icon class="fa-subsection-icon">person</mat-icon>
                                <span>Advisor & Schedule</span>
                            </div>
                            <div class="fa-subsection-body">
                                <mat-form-field appearance="outline">
                                    <mat-label>FA Advisor</mat-label>
                                    <mat-select formControlName="fa_advisor_id">
                                        <mat-option [value]="null">None</mat-option>
                                        <mat-option *ngFor="let user of users" [value]="user.id">
                                            {{ user.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Next Appointment</mat-label>
                                    <input matInput [matDatepicker]="expectedStartPicker" formControlName="expected_start_date">
                                    <mat-datepicker-toggle matSuffix [for]="expectedStartPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #expectedStartPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Sub-section: FAFSA -->
                        <div class="fa-edit-subsection">
                            <div class="fa-subsection-header">
                                <mat-icon class="fa-subsection-icon">description</mat-icon>
                                <span>FAFSA</span>
                            </div>
                            <div class="fa-subsection-body">
                                <div class="checkbox-container">
                                    <p class="checkbox-label">FAFSA Filed:</p>
                                    <mat-checkbox formControlName="fafsa_filed"></mat-checkbox>
                                </div>

                                <mat-form-field appearance="outline" *ngIf="financialAidForm.get('fafsa_filed')?.value">
                                    <mat-label>FAFSA Submitted Date</mat-label>
                                    <input matInput [matDatepicker]="fafsaPicker" formControlName="fafsa_submitted_at" [max]="today">
                                    <mat-datepicker-toggle matSuffix [for]="fafsaPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #fafsaPicker></mat-datepicker>
                                </mat-form-field>

                                <div class="fa-subsection-divider"></div>
                                <span class="fa-subsection-sublabel">Document</span>

<!-- Hidden file input -->
<input #fafsaFileInput type="file" style="display:none"
    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
    (change)="onFafsaFileSelected($event)" />

<!-- No document yet -->
<div *ngIf="!currentLead?.fafsa_document_key && !fafsaPendingFile" class="fafsa-upload-zone">
    <button mat-stroked-button (click)="fafsaFileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Upload FAFSA Document
    </button>
</div>

<!-- Pending file (not yet saved) -->
<div *ngIf="fafsaPendingFile" class="attachment-chip pending">
    <div class="file-icon-wrap">
        <mat-icon>insert_drive_file</mat-icon>
    </div>
    <div class="chip-text">
        <span class="chip-filename">{{ fafsaPendingFile.name }}</span>
        <span class="chip-meta">Ready to upload</span>
    </div>
    <div class="chip-actions">
        <button mat-icon-button class="clear-btn" matTooltip="Remove" (click)="fafsaPendingFile = null">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<!-- Existing document -->
<div *ngIf="currentLead?.fafsa_document_key && !fafsaPendingFile" class="attachment-chip">
    <div class="file-icon-wrap">
        <mat-icon>insert_drive_file</mat-icon>
    </div>
    <div class="chip-text">
        <span class="chip-filename">{{ currentLead.fafsa_document_name }}</span>
        <span class="chip-meta">Saved document</span>
    </div>
    <div class="chip-actions">
        <button mat-icon-button class="replace-btn" matTooltip="Replace" (click)="fafsaFileInput.click()">
            <mat-icon>swap_horiz</mat-icon>
        </button>
        <button mat-icon-button class="delete-btn" matTooltip="Delete" (click)="deleteFafsaDocument()">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
                            </div>
                        </div>

                        <!-- Sub-section: Process Dates -->
                        <div class="fa-edit-subsection">
                            <div class="fa-subsection-header">
                                <mat-icon class="fa-subsection-icon">event</mat-icon>
                                <span>Process Dates</span>
                            </div>
                            <div class="fa-subsection-body">
                                <mat-form-field appearance="outline">
                                    <mat-label>FA Appointment Date</mat-label>
                                    <input matInput [matDatepicker]="faApptPicker" formControlName="fa_appointment_at">
                                    <mat-datepicker-toggle matSuffix [for]="faApptPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #faApptPicker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>FA Completed Date</mat-label>
                                    <input matInput [matDatepicker]="faCompletedPicker" formControlName="fa_completed_at">
                                    <mat-datepicker-toggle matSuffix [for]="faCompletedPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #faCompletedPicker></mat-datepicker>
                                </mat-form-field>

                                <div class="fa-date-error" *ngIf="financialAidForm.hasError('appointmentAfterCompleted')">
                                    <mat-icon>error_outline</mat-icon>
                                    <span>Appointment date cannot be after completed date</span>
                                </div>
                            </div>
                        </div>

                        <!-- Sub-section: Estimation & Award -->
                        <div class="fa-edit-subsection">
                            <div class="fa-subsection-header">
                                <mat-icon class="fa-subsection-icon">payments</mat-icon>
                                <span>Estimation & Award</span>
                            </div>
                            <div class="fa-subsection-body">
                                <div class="checkbox-container">
                                    <p class="checkbox-label">SAR Received:</p>
                                    <mat-checkbox formControlName="sar_received"></mat-checkbox>
                                </div>

                                <mat-form-field appearance="outline">
                                    <mat-label>$ SAI Amount (Student Aid Index)</mat-label>
                                    <input matInput type="number" formControlName="sai_amount" min="0">
                                </mat-form-field>

                                <div class="fa-subsection-divider"></div>

                                <div class="checkbox-container">
                                    <p class="checkbox-label">Letter Sent:</p>
                                    <mat-checkbox formControlName="award_letter_sent"></mat-checkbox>
                                </div>

                                <mat-form-field appearance="outline" *ngIf="financialAidForm.get('award_letter_sent')?.value">
                                    <mat-label>Letter Sent Date</mat-label>
                                    <input matInput [matDatepicker]="awardPicker" formControlName="award_letter_sent_at">
                                    <mat-datepicker-toggle matSuffix [for]="awardPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #awardPicker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Aid Accepted</mat-label>
                                    <mat-select formControlName="aid_accepted">
                                        <mat-option value="pending">Pending</mat-option>
                                        <mat-option [value]="true">Accepted</mat-option>
                                        <mat-option [value]="false">Declined</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>$ Aid Amount</mat-label>
                                    <input matInput type="number" formControlName="aid_amount" min="0">
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- FA Notes -->
                        <mat-form-field appearance="outline">
                            <mat-label>FA Notes</mat-label>
                            <textarea matInput formControlName="fa_notes" rows="3"></textarea>
                        </mat-form-field>
                    </form>
                </ng-template>
            </mat-expansion-panel>

            <!-- Student Identification Panel -->
<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="panel-icon">perm_identity</mat-icon>
            Student Identification
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container>
        <div class="studentInfo">
            <div class="infoRow">
                <p class="label">Student ID:</p>
                <p class="value">{{ this.lead().id }}</p>
            </div>

            <div class="infoRow">
                <p class="label">Created lead:</p>
                <p class="value">{{ this.lead().created_at | customDate }}</p>
            </div>

            <div class="infoRow">
                <p class="label">Updated lead:</p>
                <p class="value">{{ this.lead().updated_at | customDate }}</p>
            </div>

            <div class="infoRow" *ngIf="currentLead?.studentUser">
                <p class="label">Username:</p>
                <p class="value">{{ currentLead.studentUser.username }}</p>
            </div>
        </div>

        <!-- Send Credentials Button -->
        <div class="credentials-action" style="margin-top: 16px; padding-top: 16px; border-top: 1px solid var(--border-color);">
            <button 
                mat-stroked-button 
                color="primary" 
                (click)="sendCredentials()"
                [disabled]="!currentLead?.studentUser">
                <mat-icon>mail_outline</mat-icon>
                Reset Credentials
            </button>
            <p class="helper-text" *ngIf="currentLead?.studentUser" style="margin-top: 8px; font-size: 12px; color: var(--text-secondary);">
                Reset login credentials to {{ currentLead.email }}
            </p>
            <p class="helper-text" *ngIf="!currentLead?.studentUser" style="margin-top: 8px; font-size: 12px; color: var(--text-secondary);">
                No student account associated with this lead
            </p>
        </div>
    </ng-container>
</mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>